// extracted by mini-css-extract-plugin
export var noSpinners = "_ne-6";
export var percentageInput = "_ne-7";
export var variantColor1 = "_ne-0";
export var variantColor2 = "_ne-1";
export var variantColor3 = "_ne-2";
export var variantColor4 = "_ne-3";
export var variantColor5 = "_ne-4";
export var variantColor6 = "_ne-5";